import NodeSource from "Areas/SharedFeatures/types/nodeSource";
import { DRAGGABLE_TYPES } from "Common/componentUtils/constants";
import { uuid7 } from "Common/uuid7";
import { Rect } from "yfiles";
import { NODE_MIN_SIZE } from "../../constants";
import addOrUpdateNodeLabel from "../nodeRendering/addOrUpdateNodeLabel";
export default (graphComponentRef, callback) => (data, e) => {
    var _a;
    try {
        if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.div))
            return;
        const textContent = data[DRAGGABLE_TYPES.DOCUMENT_OBJECT];
        const content = JSON.parse(textContent);
        const { top, left } = graphComponentRef.current.div.getBoundingClientRect();
        const { width, height } = NODE_MIN_SIZE;
        const x = (e.clientX - left) / graphComponentRef.current.zoom + graphComponentRef.current.viewPoint.x;
        const y = (e.clientY - top) / graphComponentRef.current.zoom + graphComponentRef.current.viewPoint.y;
        const userObject = new NodeSource(uuid7(), content, width, height);
        userObject.SourceCreated = userObject.Created;
        const node = graphComponentRef.current.graph.createNode(new Rect(x, y, width, height), null, userObject);
        addOrUpdateNodeLabel(graphComponentRef, node, content);
        callback(node);
    }
    catch (ex) {
        console.warn(ex);
    }
};
